import { render } from "./AppTopbar.vue?vue&type=template&id=5acb7db6&scoped=true"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=5acb7db6&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acb7db6"]])

export default __exports__